<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-card class="card--flex-toolbar" style="height: calc(100dvh - 64px - 48px);">
        <v-toolbar card>
        <v-toolbar-title>
          <v-layout>
            <v-flex>
              <v-btn flat icon @click="prevMonth">
                <v-icon dark>keyboard_arrow_left</v-icon>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-menu
                v-model="yearMonthMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="yearMonth"
                    prepend-icon="event"
                    readonly
                    :loading="restDayLoading"
                    v-on="on"/>
                </template>
                <v-date-picker
                  v-model="yearMonth"
                  no-title
                  type="month"
                  locale="ko"
                  @input="yearMonthMenu = false">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-btn flat icon @click="nextMonth">
                <v-icon dark>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-flex>
            </v-layout>
          </v-toolbar-title>

          <v-spacer></v-spacer>
<!--
          <v-select
            v-model="selectedCheckerId"
            :items="checkers"
            item-value="id"
            item-text="name"
            :label="selectorLabel"
            :loading="checkersLoading"
            ref="selector">
          </v-select> -->

          <v-btn icon :disabled="!selectedChecker || originAttendCount < 1">
            <v-icon color="error" @click="confirmRollback">history</v-icon>
          </v-btn>
          <v-btn icon :disabled="!selectedChecker">
            <v-icon @click="printPreview">print</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider></v-divider>
        <v-progress-linear v-show="reportsLoading || attendsLoading" color="blue" indeterminate height="2" style="margin : 0 auto ;" ></v-progress-linear>
        <v-layout style="height: calc(100% - 64px)">
          <v-flex xs3>
            <div style="overflow-y: auto; height: calc(100%);">
              <v-list two-line>
                <v-list-tile>
                  <v-btn-toggle v-model="selectedEmploymentStatus" :mandatory="true">
                    <v-btn value="all" color="info" outline flat><v-icon v-if="selectedEmploymentStatus === 'all'">check</v-icon>전체</v-btn>
                    <v-btn value="working" color="info" outline><v-icon v-if="selectedEmploymentStatus === 'working'">check</v-icon>근무</v-btn>
                    <v-btn value="leave" color="info" outline><v-icon v-if="selectedEmploymentStatus === 'leave'">check</v-icon>휴직</v-btn>
                    <v-btn value="resigned" color="info" outline><v-icon v-if="selectedEmploymentStatus === 'resigned'">check</v-icon>퇴사</v-btn>
                  </v-btn-toggle>
                </v-list-tile>
                <v-list-tile v-for="(checker, checkerIndex) in filteredCheckers"
                  :key="checkerIndex"
                  @click="() => {
                    selectedCheckerId = checker.id
                  }">

                  <v-list-tile-action>
                    <v-icon v-if="selectedCheckerId === checker.id" color="pink">star</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ checker.name }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ phoneNumberFormat(checker.phoneNumber) }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <span class="caption">{{ getEmploymentStatusText(checker.employmentStatus) }}</span>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </div>
          </v-flex>
          <v-flex xs9>
            <v-sheet class="scroll-y" style="height: 100%;">
              <v-alert :value="true" type="info" outline>출력시 "머리글과 바닥글" 해제 하세요.</v-alert>
              <v-alert :value="totalPage > 1" type="warning" outline>전체 페이지수 ({{ totalPage }})</v-alert>
              <div id="attendDocument" class="attendance-container attendance-document">

                <!-- <monthly-page v-for="i in [0, 1, 2, 3, 4]" -->
                <monthly-page v-for="i in totalPage"
                  :key="i"

                  :checker="selectedChecker"
                  :place-aliases="checkerPlaceAliases"
                  :charger-aliases="checkerChargerAliases"
                  :reports="reports"
                  :attends="attends"
                  :year-month="yearMonth"
                  :rest-day-items="restDayItems"
                  :total-page="totalPage"
                  :current-page="i"
                  @snackbar="(msg) => $emit('snackbar', msg)"
                  @cellEditClick="onCellEditClick">
                </monthly-page>
              </div>
            </v-sheet>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" max-width="500px">
      <daily-data-editor
        v-if="selectedChecker && yearMonth && selectedCell"
        :checker="selectedChecker"
        :place-aliases="checkerPlaceAliases"
        :charger-aliases="checkerChargerAliases"
        :year-month="yearMonth"
        :cell="selectedCell"
        @save="upsertAttends"
        @reset="deleteAttends"
        @close="dialog = false">
      </daily-data-editor>
    </v-dialog>
  </v-layout>

</template>

<script>
import moment from 'moment'
import MonthlyPage from './MonthlyPage'
import DailyDataEditor from './DailyDataEditor'
import '@/assets/css/AttendanceDocument.css'
import firebase from 'firebase/compat/app'
import axios from 'axios'
import {Util} from '../../Util'

export default {
  components: {
    'monthly-page': MonthlyPage,
    'daily-data-editor': DailyDataEditor
  },
  props: {
  },
  data () {
    return {
      yearMonth: moment().format('YYYY-MM'),
      yearMonthMenu: false,

      reports: [],
      attends: [],
      checkers: [],
      selectedCheckerId: null,
      checkerPlaceAliases: [],
      checkerChargerAliases: [],

      dialog: false,
      selectedCell: null,

      restDayItems: [],

      reportsLoading: false,
      attendsLoading: false,
      checkersLoading: false,
      restDayLoading: false,

      selectedEmploymentStatus: 'working'
    }
  },
  watch: {
    '$route' (to, from) {
      // this.getReportsAndAttends()
    },
    yearMonth: {
      async handler (to) {
        // console.log('start', _old + ' -> ' + _new, moment(_new).startOf('month').startOf('week').format('YYYY-MM-DD'))

        // await 처리하여 공휴일 정보가져와 자동 공가처리 함
        await this.getRestDeInfo(to.split('-')[0], to.split('-')[1])

        if (this.selectedCheckerId) {
          await this.getReports()
          await this.getAttends()
          this.setAutoRestDays()
          this.setAutoAnnualDays()
        }
      },
      immediate: true
    },
    selectedCheckerId: {
      async handler (to, from) {
        if (to) {
          await this.getReports()
          await this.getAttends()
          this.setAutoRestDays()
          this.setAutoAnnualDays()
        } else {
          this.reports = []
          this.attends = []
          this.selectedCell = null
          this.checkerPlaceAliases = []
          this.checkerChargerAliases = []
        }
      }
    },
    selectedChecker (to, from) {
      this.getCheckerPlaces()
    },
    dialog (to, from) {
      if (!to) { // 닫힐때
        this.$nextTick(() => {
          setTimeout(() => {
            this.selectedCell = null
          }, 300)
        })
      }
    },
    selectedEmploymentStatus () {
      this.selectedCheckerId = null
    }
  },
  computed: {
    selectorLabel () {
      return '점검자를 선택하세요.'
    },
    selectedChecker () {
      if (this.selectedCheckerId) {
        return this.checkers.find(item => item.id === this.selectedCheckerId)
      }
    },
    year () {
      return moment(this.yearMonth, 'YYYY-MM').format('YYYY')
    },
    attendDocPath () {
      // return `attendances/${this.year}/${this.selectedCheckerId}/${this.yearMonth}`
      return `attendances/${this.selectedChecker.group}/${this.yearMonth}/${this.selectedCheckerId}`
    },
    attendDaysCollectionPath () {
      return `${this.attendDocPath}/days`
    },
    // 페이지 구분 위해 전체 점검일 중 가장 많았던 점검일의 점검 수
    maxDailyAttendsCount () {
      // console.log('reports', this.reports)
      // console.log('attends', this.attends)

      if (!this.reports && !this.attends) {
        return 0
      }

      if (this.reports.length === 0 && this.attends.length === 0) {
        return
      }

      let maxCount = 0
      const lastDay = moment(this.yearMonth, 'YYYY-MM').daysInMonth()
      for (let i = 1; i <= lastDay; i++) {
        const day = String(i).padStart(2, '0')
        const date = `${this.yearMonth}-${day}`

        // 단, 해당일에 attends 가 있으면 attends 가 우선 임.
        const reportsCnt = this.reports.filter(r => r.date === date).length
        const dailyAttend = this.attends.find(a => a.date === date)

        if (dailyAttend) {
          const attendCount = dailyAttend.attends ? dailyAttend.attends.length : 0
          const timeAffectsCount = dailyAttend.timeAffects ? dailyAttend.timeAffects.length : 0
          maxCount = Math.max(maxCount, attendCount + timeAffectsCount)
        } else {
          maxCount = Math.max(maxCount, reportsCnt)
        }
      }

      return maxCount
    },
    totalPage () {
      if (this.maxDailyAttendsCount > 0) {
        const DAILY_MAX = 5
        return Math.ceil(this.maxDailyAttendsCount / DAILY_MAX)
      }

      return 1
    },
    originAttendCount () {
      if (!this.attends) {
        return -1
      }

      return this.attends.filter(a => a.id !== 'AUTO_REST_DAY').length
    },
    filteredCheckers () {
      if (!this.checkers) {
        return []
      }

      if (this.selectedEmploymentStatus === 'all') {
        return this.checkers
      }

      return this.checkers.filter(c => c.employmentStatus === this.selectedEmploymentStatus)
    }
  },
  created () {
    this.$emit('title', '출근부')
    this.getCheckers()
  },
  methods: {
    prevMonth () {
      this.yearMonth = moment(this.yearMonth, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM')
    },
    nextMonth () {
      const next = moment(this.yearMonth, 'YYYY-MM').add(1, 'month')
      const now = moment() // 오늘 날짜

      // 이번달(YYYY-MM) 기준 비교
      const currentMonth = now.format('YYYY-MM')
      const nextMonth = next.format('YYYY-MM')

      // 이번 달 이후면 막기
      if (nextMonth > currentMonth) {
        // 아무것도 안 하고 종료
        return
      }

      this.yearMonth = nextMonth
    },
    printPreview () {
      const DIV_ID = 'printDiv'
      let printDiv = document.querySelector(`#${DIV_ID}`)

      if (!printDiv) {
        const html = document.querySelector('html')
        printDiv = document.createElement('DIV')
        printDiv.id = DIV_ID
        html.appendChild(printDiv)
      }

      const printContents = document.querySelector('#attendDocument').outerHTML
      printDiv.innerHTML = printContents
      printDiv.style.display = 'block'
      document.body.style.display = 'none'
      window.print()
      document.body.style.display = 'block'
      printDiv.style.display = 'none'
      printDiv.innerHTML = ''
    },
    async getReports () {
      if (!this.selectedCheckerId) {
        return
      }

      this.reportsLoading = true
      this.reports = []

      return this.$fs.collection('reports')
        .where('checkerRef', '==', this.$fs.collection('checkers').doc(this.selectedCheckerId))
        .where('created', '>=', moment(this.yearMonth).startOf('month').toDate())
        .where('created', '<=', moment(this.yearMonth).endOf('month').toDate())
        .get().then((querySnapshot) => {
          const tempReports = []
          querySnapshot.forEach((doc) => {
            var item = doc.data()
            item.id = doc.id
            item.date = moment(item.created.toDate()).format('YYYY-MM-DD')
            tempReports.push(item)
          })

          this.reports = tempReports
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
            console.log(error)
          }
        }).finally(() => {
          this.reportsLoading = false
        })
    },
    async getAttends () {
      if (!this.selectedCheckerId) {
        return
      }

      this.attendLoading = true
      this.attends = []

      return this.$fs.collection(this.attendDaysCollectionPath)
        .get().then((querySnapshot) => {
            const tempAttends = []

            querySnapshot.forEach((doc) => {
              var item = doc.data()
              item.id = doc.id
              tempAttends.push(item)
            })

            this.attends = tempAttends
          }).catch(error => {
            if (error) {
              // TODO 오류 처리
              console.log(error)
            }
          }).finally(() => {
            this.attendLoading = false
          })
    },
    async getCheckerPlaces () {
      this.checkersLoading = true
      this.checkerPlaceAliases = []
      this.checkerChargerAliases = []

      if (!this.selectedChecker || !this.selectedChecker.placeRefs) {
        this.checkersLoading = false
        return
      }

      const ids = this.selectedChecker.placeRefs.map(ref => ref.id)

      if (ids.length === 0) {
        this.checkersLoading = false
        return
      }

      // TODO: 장소로만 가져오면 안됨. 같은 장소에 장비가 두대 인 경우가 있음 (강영미-한밭수목원)
      try {
        const chunks = []
        const chunkSize = 10

        // ❶ ids 배열을 10개씩 자르기
        for (let i = 0; i < ids.length; i += chunkSize) {
          chunks.push(ids.slice(i, i + chunkSize))
        }

        const places = []

        // ❷ 각각의 청크에 대해 쿼리 실행
        for (const chunk of chunks) {
          const querySnapshot = await this.$fs
            .collection('places')
            .where(firebase.firestore.FieldPath.documentId(), 'in', chunk)
            .get()

          querySnapshot.forEach(doc => {
            places.push({ id: doc.id, ...doc.data() })
          })
        }

        const chargerAliases = []
        for (const p of places) {
          if (p.chargerRefs && p.chargerRefs.length > 1) {
            const chargerIds = p.chargerRefs.map(cr => cr.id)
            const querySnapshot = await this.$fs
              .collection('chargers')
              .where(firebase.firestore.FieldPath.documentId(), 'in', chargerIds)
              .get()

            querySnapshot.forEach(doc => {
              // console.log(doc.data())
              chargerAliases.push(`${p.name}(${doc.data().managementNumber})`)
            })
          } else {
            chargerAliases.push(p.name)
          }
        }

        // ❸ name 기준 정렬 (orderBy 사용 불가 — in 쿼리는 orderBy 제한 있음)
        chargerAliases.sort((a, b) => a.localeCompare(b, 'ko'))
        places.sort((a, b) => a.name.localeCompare(b.name, 'ko'))

        this.checkerChargerAliases = chargerAliases
        this.checkerPlaceAliases = places.map(p => p.name)
      } catch (e) {
        console.error(e)
      } finally {
        this.checkersLoading = false
      }
    },
    async getCheckers () {
      this.checkersLoading = true
      this.checkers = []

      this.$fs.collection('checkers')
        .where('group', '==', this.$store.state.session.group)
        .orderBy('name')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id
            this.checkers.push(item)
            // this.datas.push({ divider: true, inset: false })
            // console.log(doc.data())
          })

          this.checkersLoading = false
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
          }
          this.checkersLoading = false
        })
    },
    onCellEditClick (cell) {
      this.selectedCell = cell
      this.dialog = true
    },
    upsertAttends ({workType, status, attends, timeAffects, memo}) {
      if (!attends || !this.yearMonth || !this.selectedCheckerId || !this.selectedCell) {
        return
      }

      const day = String(this.selectedCell.head.date).padStart(2, '0')
      const date = `${this.yearMonth}-${day}`
      // console.log('upsertAttends', attends, `${this.yearMonth}/users/${this.selectedCheckerId}/${date}`)
      const docId = `${date}`

      const data = {
        group: this.selectedChecker.group,
        checkerId: this.selectedCheckerId,
        checkerRef: this.$fs.collection('checkers').doc(this.selectedCheckerId),
        date: date,
        workType, // WORK, NON_WORK(ANNUAL_LEAVE, SICK_LEAVE, PUBLIC_LEAVE, SPECIAL_LEAVE, ABSENT), TIME_AFFECT(LATE, EARLY_LEAVE, OUT)
        status, // WORK, ANNUAL_LEAVE, SICK_LEAVE, PUBLIC_LEAVE, SPECIAL_LEAVE, ABSENT, LATE, EARLY_LEAVE, OUT
        attends,
        timeAffects,
        memo,
        updated: firebase.firestore.FieldValue.serverTimestamp()
      }

      // {
      //   "date": "2025-12-11",
      //   "workType": "TIME_AFFECT",
      //   "status": "OUT",   // 대표 상태 (여러 개면 우선순위로 1개만 표시)
      //   "attends": [
      //     { "time": "09:20", "place": "서구센터" },
      //     { "time": "16:10", "place": "둔산동" }
      //   ],
      //   "timeAffects": [
      //     { "type": "LATE", "time": "09:20" },
      //     { "type": "OUT", "from": "14:10", "to": "15:30" }
      //   ]
      // }

      data.attends = data.attends.filter(a => a.time && a.place)
      data.attends.sort((a, b) => a.time.localeCompare(b.time))

      // console.log(data)

      // attends 반응형 문제로 dialog 먼저 닫음
      this.dialog = false
      // this.$fs.collection(`attendances/${this.yearMonth}/days`)
      // this.$fs.collection(`attendances/${this.selectedChecker.group}/${this.yearMonth}`)
      this.$fs.collection(this.attendDaysCollectionPath)
        .doc(docId)
        .set(data, {merge: true})
        .then(() => {
          const attIndex = this.attends.findIndex(a => a.id === docId)

          if (attIndex > -1) { // 데이터 없으면 pass
            // Object.assign(this.attends[attIndex],  {...data, updated: new Date()})
            this.attends.splice(attIndex, 1, {...data, updated: new Date(), id: docId})
          } else {
            const autoAttIndex = this.attends.findIndex(a => a.id === 'AUTO_REST_DAY' && a.date === date)

            if (autoAttIndex > -1) {
              this.attends.splice(autoAttIndex, 1, {...data, updated: new Date(), id: docId})
            } else {
              this.attends.push({...data, updated: new Date(), id: docId})
            }
          }
        }).then(() => {
          this.setAutoRestDays()
          this.setAutoAnnualDays()
        }).catch((error) => {
          console.error('Error adding document: ', error)
        }).finally(() => {
          // this.dialog = false
        })
    },
    deleteAttends () {
      if (!this.yearMonth || !this.selectedCheckerId || !this.selectedCell) {
        return
      }

      const day = String(this.selectedCell.head.date).padStart(2, '0')
      const date = `${this.yearMonth}-${day}`
      // console.log('upsertAttends', attends, `${this.yearMonth}/users/${this.selectedCheckerId}/${date}`)
      const docId = `${date}`

      const attIndex = this.attends.findIndex(a => a.id === docId)
      if (attIndex <= -1) { // 데이터 없으면 pass
        this.dialog = false
        return
      }

      // attends 반응형 문제로 dialog 먼저 닫음
      this.dialog = false
      this.$fs.collection(this.attendDaysCollectionPath)
        .doc(docId)
        .delete()
        .then(() => {
          if (attIndex > -1) {
            this.attends.splice(attIndex, 1)

            // TODO: 만일 공휴일이면....
          }
        }).then(() => {
          this.setAutoRestDays()
          this.setAutoAnnualDays()
        }).catch((error) => {
          console.error('Error adding document: ', error)
        }).finally(() => {
          // this.dialog = false
        })
    },
    async getRestDeInfo (year, month) {
      try {
        this.restDayLoading = true
        const response = await axios.get('http://apis.data.go.kr/B090041/openapi/service/SpcdeInfoService/getRestDeInfo', {
          params: {
            solYear: year,
            solMonth: month,
            numOfRows: 31,
            serviceKey: '4I8FjGmEPuoSXw65B9Rqk/HROcTGQV1StfV/2WRhxuRl/JdETbGH9ZDy1/5qZM6rcXuOzat+mCCZXvDSTXdMLA=='
          }
        })

        if (response.data.response.header.resultCode !== '00') {
          this.$emit('snackbar', '공휴일 정보를 가져오지 못했습니다.')
          return
        }

        const items = response.data.response.body.items
        if (Array.isArray(items.item)) {
          // { item: T[] } 구조
          this.restDayItems = items.item
        } else if (items.item) {
          // { item: T } 단일 객체
          this.restDayItems = [items.item]
        } else if (!Array.isArray(items)) {
          // items가 배열도 아니고 object도 아님
          this.restDayItems = []
        }

        // [{item: {dateKind, dateName, isHoliday, locdate, seq}}]

        // http://apis.data.go.kr/B090041/openapi/service/SpcdeInfoService/getRestDeInfo
        // solYear
        // solMonth
        // 4I8FjGmEPuoSXw65B9Rqk/HROcTGQV1StfV/2WRhxuRl/JdETbGH9ZDy1/5qZM6rcXuOzat+mCCZXvDSTXdMLA==

        // 결과코드 resultCode 필 00 00:성공
        // 결과메시지 resultMsg 필 NORMAL SERVICE
        // 날짜 locdate 8 옵션 20150301 날짜
        // 순번 seq 옵션 1 순번
        // 종류 dateKind 2 옵션 00 종류
        // 공공기관 휴일여부 isHoliday 50 옵션 Y 공공기관 휴일여부
        // 명칭 dateName 50 옵션 삼일절 명칭
        // 페이지당항목수 numOfRows 옵션 10
        // 페이지 pageNo 옵션 1
        // 모든항목수 totalCount 옵션 210114
      } catch (err) {
        console.log(err)
      } finally {
        this.restDayLoading = false
      }
    },
    // 자동 공가 처리..., 일요일, 토요일 제외
    setAutoRestDays () {
      if (!this.reports || this.reports.length === 0) {
        return
      }

      const today = moment().startOf('day')

      this.restDayItems.forEach(d => {
        const date = moment(d.locdate.toString(), 'YYYYMMDD')
        const day = date.day()
        const m = moment(date, 'YYYY-MM-DD')

        // 오늘 이후는 제외
        if (m.isSameOrAfter(today, 'day')) return

        if (day === 0 || day === 6 || day === 3) { // 일, 토, 수 skip
          return
        }

        const r = this.reports.filter(r => r.date.replaceAll('-', '') === d.locdate.toString())
        const a = this.attends.filter(r => r.date.replaceAll('-', '') === d.locdate.toString())

        if ((r.length + a.length) === 0) {
          this.attends.push({
            id: 'AUTO_REST_DAY',
            group: this.selectedChecker.group,
            checkerId: this.selectedCheckerId,
            checkerRef: this.$fs.collection('checkers').doc(this.selectedCheckerId),
            date: date.format('YYYY-MM-DD'),
            workType: 'NON_WORK',
            status: 'PUBLIC_LEAVE',
            attends: [],
            timeAffects: []
          })
        }
      })
    },
    // 자동 연차 처리..., 일요일, 토요일 제외
    setAutoAnnualDays () {
      if (!this.reports || this.reports.length === 0) {
        return
      }

      const today = moment().startOf('day')
      const lastDay = moment(this.yearMonth, 'YYYY-MM').daysInMonth()
      let workDaysCount = 0

      for (let i = 1; i <= lastDay; i++) {
        if (workDaysCount >= 16) break

        const date = `${this.yearMonth}-${String(i).padStart(2, '0')}`

        const m = moment(date, 'YYYY-MM-DD')
        // ✅ 오늘 포함 이후는 모두 skip
        if (m.isSameOrAfter(today, 'day')) continue

        const day = moment(date, 'YYYY-MM-DD').day()

        if (day === 0 || day === 6 || day === 3) continue // 일, 토, 수

        // // 단, 해당일에 attends 가 있으면 attends 가 우선 임.
        const reportsCnt = this.reports.filter(r => r.date === date).length
        let dailyAttend = this.attends.find(a => a.date === date)

        if (reportsCnt === 0 && !dailyAttend) {
          dailyAttend = {
            id: 'AUTO_REST_DAY',
            group: this.selectedChecker.group,
            checkerId: this.selectedCheckerId,
            checkerRef: this.$fs.collection('checkers').doc(this.selectedCheckerId),
            date: date,
            workType: 'NON_WORK',
            status: 'ANNUAL_LEAVE',
            attends: [],
            timeAffects: []
          }
          this.attends.push(dailyAttend)
        }

        if (reportsCnt > 0 ||
          (dailyAttend &&
            (dailyAttend.workType === 'WORK' ||
            (dailyAttend.workType === 'NON_WORK' && ['ANNUAL_LEAVE', 'SICK_LEAVE', 'PUBLIC_LEAVE'].includes(dailyAttend.status))
        ))) {
          // console.log('aaa', workDaysCount, i, dailyAttend ? dailyAttend.workType : '')
          workDaysCount++
        }
      }

      // if (this.reports.length < 1) {
      //   return
      // }

      // // ✅ 오늘 기준
      // const today = moment().startOf('day')
      // const lastDay = moment(this.yearMonth, 'YYYY-MM').daysInMonth()

      // // ✅ 1. 해당 월의 "마지막 근무일" 찾기
      // let lastWorkDate = null

      // for (let i = 1; i <= lastDay; i++) {
      //   const date = `${this.yearMonth}-${String(i).padStart(2, '0')}`

      //   const hasReport = this.reports.some(r => r.date === date)
      //   const hasAttend = this.attends.some(a => a.date === date)

      //   if (hasReport || hasAttend) {
      //     lastWorkDate = moment(date, 'YYYY-MM-DD')
      //   }
      // }

      // // ✅ 근무한 날이 아예 없는 경우 → 아무것도 안 함
      // if (!lastWorkDate) {
      //   return
      // }

      // // ✅ 2. 마지막 근무일 이전만 자동 연차 처리
      // for (let i = 1; i <= lastDay; i++) {
      //   const date = `${this.yearMonth}-${String(i).padStart(2, '0')}`
      //   const m = moment(date, 'YYYY-MM-DD')

      //   // 오늘 이후는 제외
      //   if (m.isSameOrAfter(today, 'day')) continue

      //   // 마지막 근무일 이후는 제외
      //   if (m.isSameOrAfter(lastWorkDate, 'day')) continue

      //   const day = m.day()
      //   if (day === 0 || day === 6 || day === 3) continue // 일, 토, 수

      //   const reportsCnt = this.reports.filter(r => r.date === date).length
      //   const dailyAttend = this.attends.find(a => a.date === date)

      //   // 이미 데이터 있으면 skip
      //   if (reportsCnt > 0 || dailyAttend) continue

      //   // ✅ 앞 구간만 연차 자동 처리
      //   this.attends.push({
      //     id: 'AUTO_REST_DAY',
      //     group: this.selectedChecker.group,
      //     checkerId: this.selectedCheckerId,
      //     checkerRef: this.$fs.collection('checkers').doc(this.selectedCheckerId),
      //     date: date,
      //     workType: 'NON_WORK',
      //     status: 'ANNUAL_LEAVE',
      //     attends: [],
      //     timeAffects: []
      //   })
      // }
    },
    phoneNumberFormat (phoneNumber) {
      return phoneNumber ? Util.phoneNumberFormat(phoneNumber, true, false) : ''
    },
    async confirmRollback () {
      if (!confirm(`${this.selectedChecker.name}의 ${this.yearMonth} 출근부를 초기화 하시겠습니까?`)) {
        return
      }

      try {
        if (this.attendDaysCollectionPath.indexOf(this.selectedCheckerId) === -1) {
          return
        }

        this.$fs.collection(this.attendDaysCollectionPath)
          .get().then((querySnapshot) => {

            let batch = this.$fs.db().batch()

            querySnapshot.forEach((doc) => {
              batch.delete(doc.ref)
            })

            batch.delete(this.$fs.collection(`attendances/${this.selectedChecker.group}/${this.yearMonth}`).doc(this.selectedCheckerId))
            batch.commit()
              .then(async () => {
                await this.getReports()
                await this.getAttends()
                this.setAutoRestDays()
                this.setAutoAnnualDays()
              })
          }).catch(error => {
            if (error) {
              // TODO 오류 처리
            }
          })
      } catch (e) {
        console.error(e)
      }
    },
    getEmploymentStatusText (employmentStatus) {
      switch (employmentStatus) {
        case 'working': return '근무'
        case 'leave': return '휴직'
        case 'resigned': return '퇴사'
        case 'pending': return '입사 대기'
      }
    }
  }
}
</script>

<style scoped>
.attendance-container {
  /* padding: 16px;
  max-width: 800px;
  text-align: center;
  margin-left: auto;
  margin-right: auto; */
}

#thumbnails {
  zoom: 0.2;
  margin: 100px auto;
  text-align: center;
}

#thumbnails .attendance-page {
  border: 1px solid #ccc;
  /* margin: 40px auto; */
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/Attendance/ReportMonthlyAttendance.vue